<a routerLink="/user/studentassesment" [queryParams]="{aid:assessment.id,batchid: this.assessment.batchid,classid:assessment.classid,target:1}" class="group-link d-flex">
  <img src="{{moduleimageurl}}" alt="Banner image for {{assessment.coursetitle}}" class="avatar rounded-circle shadow-sm-darker mr-2">
  <div>
    <h3 class="text-sm font-weight-500 text-primary-darker mb-0">{{assessment.name}}</h3>
    <p class="text-xs m-0">
      <span class="font-weight-500">{{assessment.coursetitle}}<ng-template [ngIf]="assessment.coursecode"> ({{assessment.coursecode}})</ng-template></span>
      <br>
      <span class="font-weight-500">Start: </span><time datetime="">{{assessment.starttime}}</time>
      <br>
      <span class="font-weight-500">Due: </span><time datetime="">{{assessment.duedate}}</time>
    </p>
  </div>
</a>
